
export const REDUCER_NAME = "billingInvoiceSlice";

export interface iBillingInvoiceRequest {
  companyname: string;
  billingemail: string;
  phonenumber: string;
  gstin: string;
  address: string;
  city: string;
  state: string;
  country: string;
  pincode: string;
}

export interface iBillingInvoiceState {
  isLoading: boolean;
  isSuccess: boolean;
  error: string | null;
}


